// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1X5cI","productName":"Table_productName__3j1X7"};